import React from 'react';
import { translateStatus } from '../i18n/translations';
import { useLanguage } from '../contexts/LanguageContext';
import { ArrowRight } from 'lucide-react';

const STATUS_FLOW = [
  'commandée',
  'impression',
  'couture',
  'livraison bureau',
  'en cours de livraison client',
  'livrée'
];

export const StatusFlowBar = () => {
  const { t } = useLanguage();

  return (
    <div data-testid="status-flow-bar" className="flex items-center flex-wrap gap-1 mt-2">
      {STATUS_FLOW.map((status, i) => (
        <React.Fragment key={status}>
          <span className={`text-[11px] font-semibold px-2 py-0.5 rounded ${
            status === 'commandée' ? 'bg-blue-100 text-blue-800' :
            status === 'impression' ? 'bg-purple-100 text-purple-800' :
            status === 'couture' ? 'bg-indigo-100 text-indigo-800' :
            status === 'livraison bureau' ? 'bg-yellow-100 text-yellow-800' :
            status === 'en cours de livraison client' ? 'bg-orange-100 text-orange-800' :
            'bg-emerald-100 text-emerald-800'
          }`}>
            {translateStatus(status, t)}
          </span>
          {i < STATUS_FLOW.length - 1 && (
            <ArrowRight size={12} className="text-slate-400 flex-shrink-0" />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};
